/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
query!:string;
appointment_list:any[]=[];
today_appointment_list:any[]=[];
brands_list:any;
searchData:any;
placeholder_samples = ["name","category","type","brands"];
}
